<template>
  <div class="resume">
    <div class="resume-editor" ref="editorFrom">
      <div>
        <!-- 求职意向 -->
        <div class="resumeSection">
          <div>
            <h2 class="resumeSection__title">在职状态</h2>
          </div>
          <div class="resumeSection__form">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item label="在职状态" prop="entryStatus">
                <el-select
                  v-model="form.entryStatus"
                  placeholder="请选择在职状态"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in enteyOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="入职公司的名称" prop="companyName">
                <el-input
                  v-model="form.companyName"
                  placeholder="请输入入职公司的名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="入职岗位的名称" prop="positionName">
                <el-input
                  v-model="form.positionName"
                  placeholder="请输入入职岗位的名称"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div ref="footerAction" class="resumeEditor-footerAction">
      <el-button round @click="$router.push('/resume')">取消</el-button>
      <el-button size="medium" @click="submit" type="primary">保存</el-button>
    </div>
  </div>
</template>
  
  <script>
import { personalInfo, entryInfoCommit } from "@/api/index";
import { Debounce } from "@/helper/utilities.js";
export default {
  name: "resume-entry",
  data() {
    return {
      enteyOptions: [
        {
          value: "0",
          label: "在职",
        },
        {
          value: "1",
          label: "非在职",
        },
      ],
      form: {
        miniProgramEntryId: undefined,
        miniProgramUserId: undefined,
        entryStatus: undefined,
        companyName: undefined,
        positionName: undefined,
      },
      rules: {
        entryStatus: [
          { required: true, message: "在职状态不能为空", trigger: "change" },
        ],
        companyName: [
          {
            required: true,
            message: "入职公司的名称不能为空",
            trigger: "blur",
          },
        ],
        positionName: [
          {
            required: true,
            message: "入职岗位的名称不能为空",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.getPersonalInfo();
  },
  methods: {
    getPersonalInfo() {
      personalInfo()
        .then((res) => {
          if (res.code == 200) {
            if (res.data.entry) {
               this.form = res.data.entry
            }
          }
        })
        .catch((err) => {});
    },

    submit: Debounce(function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
            entryInfoCommit(this.form).then((res) => {
            if (res.code == 200) {
              this.$router.go(-1);
              this.$message({
                showClose: true,
                message: "保存成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "warning",
              });
            }
          });
        }
      });
    }, 1000),
  },
};
</script>
  
  <style lang="less" scoped>
.resume {
  margin-bottom: 30px;
}
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 30px 0;
}
.resumeEditor-footerAction {
  width: 900px;
  margin: auto;
  z-index: 33;
  text-align: right;
  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}
.resumeSection {
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @border-base-color;

  &__title {
    margin-right: 180px;

    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }
  &__form {
    width: 600px;
  }
}
</style>
  